import common from './common';
import general from './general';
import genres from './genres';
import formats from './formats';
import cycles from './cycles';
import system from './system';
import users from './users';
import schools from './schools';
import items from './items';
import lists from './lists';
import components from './components';
import subjects from './subjects';
import certificates from './certificates';
import curriculums from './curriculums';
import series from './series';
import itemTypes from './itemTypes';
import levelMaps from './levelMaps';

const en = {
	common,
	genres,
	general,
	system,
	users,
	schools,
	items,
	lists,
	components,
	subjects,
	certificates,
	curriculums,
	series,
	itemTypes,
	formats,
	cycles,
	levelMaps,
} as const;

export default en;
